import TxAddToCartPortal from "./components/TxAddToCartPortal";
import TxProductViewPortal from "./components/TxProductViewPortal";
import TxProductSettingsPortal from "./components/TxProductSettingsPortal";
import TxProductAdminPortal from "./components/TxProductAdminPortal";
import TxToSaveParams from "./components/TxToSaveParams";
import TxProductStats from "./components/TxProductStats";
import TxVariationSelect from "./components/TxVariationSelect";


export default {
    install(Vue, option) {
        Vue.component('TxAddToCartPortal', TxAddToCartPortal);
        Vue.component('TxProductViewPortal', TxProductViewPortal);
        Vue.component('TxProductSettingsPortal', TxProductSettingsPortal);
        Vue.component('TxProductAdminPortal', TxProductAdminPortal);
        Vue.component('TxToSaveParams', TxToSaveParams);
        Vue.component('TxProductStats', TxProductStats);
        Vue.component('TxVariationSelect', TxVariationSelect);
    }
};